export default __webpack_public_path__ + "static/media/022-seed bag.72a54a6d.svg";